import Tools from '@/assets/images/tools.png'
import Entension from '@/assets/images/entension.png'
import Sweep from '@/assets/images/sweep.png'
import styles from './index.module.scss'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Modal from '@/components/Modal'
import { useGetSweepGray } from '@/hooks/sweep'
import { useRef } from 'react'
import { useCheckCanManageTradePolicy } from '@/hooks/permission'
import { useCheckBackupStatus } from '@/hooks/user'

export default function Application() {
  const { t } = useTranslation()
  let navigate = useNavigate()
  const isOpenedSweep = useGetSweepGray()
  const isCheckingRef = useRef(false)
  const checkCanManageTradePolicy = useCheckCanManageTradePolicy()
  const checkBackupStatus = useCheckBackupStatus()

  const handleSweep = async () => {
    if (isCheckingRef.current) {
      return
    }

    isCheckingRef.current = true

    const [canManageTradePolicy, hasBackup] = await Promise.all([
      checkCanManageTradePolicy(),
      checkBackupStatus(),
    ])

    isCheckingRef.current = false
    if (!canManageTradePolicy) {
      Modal.info({
        title: t('autoSweep.permission'),
        content: <div className={styles.confirm}>{t('autoSweep.noPermission')}</div>,
        okText: t('common.complete'),
        closable: true,
      })
      return
    }
    if (!hasBackup) {
      Modal.info({
        title: t('autoSweep.notBackup.title'),
        content: <div className={styles.confirm}>{t('autoSweep.notBackup.desc')}</div>,
        okText: t('common.complete'),
        closable: true,
      })
      return
    }
    navigate('/application/autoSweep')
  }
  return (
    <div className={styles.container}>
      <a
        href="https://github.com/Safeheron/safeheron-offline-recovery-tool/releases"
        target="_blank"
        className={styles.imgBox}
        rel="noreferrer"
      >
        <img src={Tools} alt="" className={styles.img} />
        <span>
          Safeheron <br />
          {t('app.tools')}
        </span>
      </a>
      <a
        href="https://chrome.google.com/webstore/detail/safeheron/aiaghdjafpiofpainifbgfgjfpclngoh"
        target="_blank"
        className={styles.imgBox}
        rel="noreferrer"
      >
        <img src={Entension} alt="" className={styles.img} />
        <span>{t('app.extension')}</span>
      </a>
      {isOpenedSweep && (
        <div className={styles.imgBox} onClick={handleSweep}>
          <img src={Sweep} alt="" className={styles.img} />
          <span>Auto Sweep</span>
        </div>
      )}
    </div>
  )
}
